import React from "react";
import { RoutePermittedRole } from "shared/constants/AppConst";

export const SocioEconomicEmpowerConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/socio-economic-empower",
    component: React.lazy(() => import("./socio-economic-empower")),
  },
];
